module.exports = __webpack_public_path__ + "img/vipto1.130bb34f.png";